import {useQuery} from '@tanstack/react-query'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpGetFreelancerPayments} from '@features/payments/http/payments.http.ts'
import {captureException} from '@sentry/react'
import {FreelancerPayment} from '@features/payments/types.ts'
import {z} from 'zod'

export const useFreelancerPayments = (paymentDate: string) => {
    return useQuery({
        queryKey: [QUERY_KEYS.FREELANCER_PAYMENTS_DATES, paymentDate],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetFreelancerPayments({
                    params: {
                        response_type: 'regular',
                        date: paymentDate
                    }
                }),
                onZodError: captureException,
                responseShape: z.array(FreelancerPayment)
            })
    })
}
